export {default as BonusBannerCards} from './BonusBannerCards.connect';
